export const baseUnit = 4;
const spacingFactor = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 32];

const spacing = spacingFactor.reduce((acc, next) => {
  acc[`size${next}`] = next * baseUnit;
  return acc;
}, {});

export { spacing };
